import { EditSusunanKeluargaPayload } from "../../../../models/SusunanKeluarga";
import { getApiInstance } from "../../../api";
import mutationWrapper from "../../mutationWrapper";
import { allSusunanKeluargaKey } from "../../queries/SusunanKeluarga/useFetchAllSusunanKeluarga";
import { allSusunanKeluargaOTKey } from "../../queries/SusunanKeluarga/useFetchAllSusunanKeluargaOT";
import { checkProfileKey } from "../../queries/User/useFetchCheckProfile";
import getQueryClient from "../../queryClient";
import ApiClient from "../../../apiClient";

export async function editSusunanKeluarga(data: EditSusunanKeluargaPayload) {
  const res = await ApiClient.put(`/EditKeluarga`, data);
  return res.data[0];
}

export const useEditSusunanKeluarga = mutationWrapper(editSusunanKeluarga, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(allSusunanKeluargaKey);
    getQueryClient().invalidateQueries(allSusunanKeluargaOTKey);
    getQueryClient().invalidateQueries(checkProfileKey);
  },
});
